// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__m54dI","colBig":"styles_colBig__1DzJG","colSmall":"styles_colSmall__1HAGU","shopifyNameWrapper":"styles_shopifyNameWrapper__1W3Yy"};